"use strict";

exports.__esModule = true;
exports.default = void 0;
var _loadImage = _interopRequireDefault(require("./loadImage"));
var _preloadImages = _interopRequireDefault(require("./preloadImages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  loadImage: _loadImage.default,
  preloadImages: _preloadImages.default
};
exports.default = _default;